import React from "react";
import {
  useTogglePriceInverted,
  usePriceInverted,
  useOnchainLendingPool,
} from "../../hooks/useOnchain";
import { formatFloat } from "../../utils/format";
import { DetailsRowCustom } from "../DetailsRow";
import QuestionHelper from "../QuestionHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import useGenericCall from "../../hooks/useGenericCall";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

/**
 * Generates lending pool aggregate details.
 */
export default function CurrentPrice() {
  const priceInverted = usePriceInverted();
  const togglePriceInverted = useTogglePriceInverted();

  const data = useGenericCall(
    useOnchainLendingPool(),
    async (onchainLendingPool) => ({
      TWAPPrice: await onchainLendingPool.getTWAPPrice(),
      marketPrice: await onchainLendingPool.getMarketPrice(),
      symbolA: await (
        await onchainLendingPool.getBorrowableA().getOffchainBorrowable()
      ).getSymbol(),
      symbolB: await (
        await onchainLendingPool.getBorrowableB().getOffchainBorrowable()
      ).getSymbol(),
    }),
    [priceInverted]
  );

  if (!data) return null;

  const pair = !priceInverted
    ? data.symbolA + "/" + data.symbolB
    : data.symbolB + "/" + data.symbolA;

  return (
    <DetailsRowCustom>
      <div className="name">
        TWAP Price ({pair}){" "}
        <QuestionHelper
          text={
            "The TWAP (Time Weighted Average Price) and the current market price on Uniswap"
          }
        />
      </div>
      <div className="value">
        {formatFloat(data.TWAPPrice, 4)} (current:{" "}
        {formatFloat(data.marketPrice, 4)}){" "}
        <FontAwesomeIcon
          icon={faSyncAlt as IconProp}
          className="invert-price"
          onClick={() => togglePriceInverted()}
        />
      </div>
    </DetailsRowCustom>
  );
}
